import { useQuery } from '@tanstack/react-query';
import { press as pressApi } from '../api';

// HTML 태그 제거 (목록 미리보기용)
const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

// ISO 날짜 → YYYY.MM.DD.
const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
};

export const usePressList = (page) => {
  return useQuery({
    queryKey: ['press', 'list', page],
    queryFn: async () => {
      const { data } = await pressApi.getPress(page);
      const items = data.items.map((item) => ({
        id: item.id,
        title: item.title,
        content: stripHtml(item.content),
        date: formatDate(item.createdAt),
        image: item.thumbnailUrl || '',
      }));
      return { items, totalPages: data.meta.totalPages };
    },
  });
};

export const usePressDetail = (id) => {
  return useQuery({
    queryKey: ['press', 'detail', id],
    queryFn: async () => {
      const { data } = await pressApi.getPressDetail(id);
      return {
        title: data.title,
        content: data.content,
        image: data.thumbnailUrl || '',
        date: formatDate(data.createdAt),
      };
    },
    enabled: !!id,
  });
};
